module.exports = __webpack_public_path__ + "static/media/3.question_loop.f55975de.mp4";